import { render, staticRenderFns } from "./agreementBox.vue?vue&type=template&id=9a95ab8c&scoped=true"
import script from "./agreementBox.vue?vue&type=script&lang=js"
export * from "./agreementBox.vue?vue&type=script&lang=js"
import style0 from "./agreementBox.vue?vue&type=style&index=0&id=9a95ab8c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a95ab8c",
  null
  
)

export default component.exports